// extracted by mini-css-extract-plugin
module.exports = {"button":"button__gSrcr","buttonGroup":"buttonGroup__SaLt6","dialog":"dialog__9CYVe","dialogBody":"dialogBody__ZXG8Q","p":"p__uJhIj","switch":"switch__z8nov"};